import React from 'react';
import { useSelector } from 'react-redux';
import { ErrorBoundary, PostMetaHeaderTags } from 'mm-ui-components';
import {
    getCanonicalUrl,
    getFacebookAppId,
    getFacebookPageId, getFavicon, getSiteName,
    getPageDescription, getPageTitle, getTwitterAccount, getLogoUrl, getAmpURL, getPrevCanonicalUrl,
} from '../../store/config/config.selectors';
import {
    getCreatedAt,
    getUpdatedAt,
    getImageCover,
    getNoIndex,
    getAuthors } from '../../store/template/postPage/postPage.selectors';

export const PostMetaTagsConnected: React.FunctionComponent = () => {
    const facebookAppId = useSelector(getFacebookAppId);
    const facebookPageId = useSelector(getFacebookPageId);
    const description = useSelector(getPageDescription);
    const siteName = useSelector(getSiteName);
    const canonicalUrl = useSelector(getCanonicalUrl);
    const favicon = useSelector(getFavicon);
    const title = useSelector(getPageTitle);
    const twitterAccount = useSelector(getTwitterAccount);
    const pageImage = useSelector(getImageCover);
    const logoUrl = useSelector(getLogoUrl);
    const authors = useSelector(getAuthors);
    const createdAt = useSelector(getCreatedAt);
    const updatedAt = useSelector(getUpdatedAt);
    const ampURL = useSelector(getAmpURL);
    const prevCanonicalUrl = useSelector(getPrevCanonicalUrl);
    const noIndex = useSelector(getNoIndex);
    return <PostMetaHeaderTags {...{ facebookAppId, facebookPageId, description, siteName, canonicalUrl, favicon, title, twitterAccount, pageImage, logoUrl, authors, createdAt, updatedAt, ampURL, prevCanonicalUrl, noIndex }} />;
};
export const PostMetaTags = () => <ErrorBoundary><PostMetaTagsConnected /></ErrorBoundary>;
